<template>
  <span
    :class="[suffix, icon]"
    @click="handleClick"
    :style="{
      fontSize: `${size}px`,
    }"
  ></span>
</template>

<script>
export default {
  name: "iconfont",
  props: {
    suffix: {
      type: String,
      default: "joinmc",
    },
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style scoped>
.joinmc {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  color: var(--mc-primary-text-color);
}
</style>
